module.exports = __webpack_public_path__ + "img/ic-plus.db61c9c8.svg";